










































import { Component, Prop, Vue } from "vue-property-decorator";
import { getHumanDateTime } from "@/utility/DateUtils";

@Component
export default class DetailInstruksiSection extends Vue {
  @Prop() consent!: any;

  get instruksiItems() {
    const c = this.consent;
    return [
      { label: "Tidak melakukan RJP atau mengaktifkan CODE BLUE (Full DNR)", value: c.instruksi_no_rjp },
      { label: "Usaha komprehensif mencegah henti napas/jantung TANPA intubasi (Partial)", value: c.instruksi_tanpa_intubasi },
      { label: "Usaha suportif saja (jalan napas non-invasif, oksigen, kontrol perdarahan, posisi nyaman, bidai, anti nyeri)", value: c.instruksi_suportif }
    ];
  }

  formatDate(date) {
    return getHumanDateTime(date);
  }
}
